import "./Featuredservices.css";
import React from "react";
import { Link } from "react-router-dom";

function Featuredservices() {
  const pillars = [
    {
      k: "Women's health",
      title: "Obstetrics & gynaecology",
      desc: "Care for every stage of a woman's life, from puberty through pregnancy to menopause — pregnancy consultation, high-risk pregnancy care, PCOS and menstrual disorders, infertility treatment and laparoscopic surgery.",
      link: "/services/gynaecology",
      linkText: "Explore women's health"
    },
    {
      k: "Child care",
      title: "Paediatrics",
      desc: "A comprehensive approach to paediatric care covering both preventive and curative needs — newborn screening, immunisation, childhood illness, asthma and allergy, growth counselling and adolescent health.",
      link: "/services/pediatric",
      linkText: "Explore paediatrics"
    },
    {
      k: "General services",
      title: "Everyday medicine",
      desc: "Primary healthcare, internal medicine, minor surgical procedures, health screenings and the management of acute and chronic illness — for patients of every age in the family.",
      link: "/services/general-services",
      linkText: "Explore general services"
    }
  ];

  return (
    <section className="band tint" id="care">
      <div className="wrap">
        <p className="eyebrow">What we do</p>
        <h2 className="h-sec">Three practices, one roof.</h2>
        <p className="lede" style={{ marginTop: "20px" }}>
          A woman's health, a child's growth, and the everyday medicine a family needs in between &mdash; looked after by people who already know your history.
        </p>

        <div className="pillars">
          {pillars.map((pillar, idx) => (
            <article className="pillar" key={idx}>
              <span className="k">{pillar.k}</span>
              <h3>{pillar.title}</h3>
              <p>{pillar.desc}</p>
              <Link to={pillar.link}>{pillar.linkText} &rarr;</Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Featuredservices;
